import get from 'lodash/get';
import { getActiveRolesList } from '../../constants/dprPersonnelRoleGroups';
import {
  ADD_ROLE,
  ADD_ROLE_FAILURE,
  ADD_ROLE_SUCCESS,
  FETCH_ROLES,
  FETCH_ROLES_FAILURE,
  FETCH_ROLES_SUCCESS,
} from './types';

const initialState = {
  roles: [],
  isRolesLoading: false,
};

const roleReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_ROLES: {
      return {
        ...state,
        isRolesLoading: true,
      };
    }

    case FETCH_ROLES_SUCCESS: {
      const resData = get(action, 'response', []);
      const rows = Array.isArray(resData) ? resData : get(resData, 'rows', []);
      return {
        ...state,
        roles: getActiveRolesList(rows),
        isRolesLoading: false,
      };
    }

    case FETCH_ROLES_FAILURE: {
      return {
        ...state,
        isRolesLoading: false,
      };
    }

    case ADD_ROLE: {
      return {
        ...state,
        isRolesLoading: true,
      };
    }

    case ADD_ROLE_SUCCESS: {
      const created = get(action, 'response', null);
      if (!created || typeof created !== 'object') {
        return { ...state, isRolesLoading: false };
      }
      const createdId = created.id ?? created.roleId;
      const createdName = String(created.name ?? created.roleName ?? '').trim().toLowerCase();
      const alreadyListed = (state.roles || []).some((r) => {
        const id = r?.id ?? r?.roleId;
        const name = String(r?.name ?? r?.roleName ?? '').trim().toLowerCase();
        return (createdId != null && id === createdId) || (createdName && name === createdName);
      });
      return {
        ...state,
        roles: alreadyListed ? state.roles : [...(state.roles || []), created],
        isRolesLoading: false,
      };
    }

    case ADD_ROLE_FAILURE: {
      return {
        ...state,
        isRolesLoading: false,
      };
    }

    default: {
      return state;
    }
  }
};

export default roleReducer;
